var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"centered-layout"},[_c('v-container',{attrs:{"fluid":"","align-center":"","fill-height":"","justify-center":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }